import { useState, useEffect } from 'react'

const interactionEvents = [
  'click',
  'mousemove',
  'keydown',
  'DOMMouseScroll',
  'mousewheel',
  'mousedown',
  'touchstart',
  'touchmove',
  'focus',
]

const useUserInteraction = () => {
  const [userInteracted, setUserInteracted] = useState(false)

  const removeScrollHandler = () => {
    interactionEvents.forEach(eventName => {
      window.removeEventListener(eventName, scrollHandler)
    })
  }

  const scrollHandler = () => {
    setUserInteracted(true)
    removeScrollHandler()
  }

  useEffect(() => {
    if (!window.grecaptcha && !userInteracted) {
      interactionEvents.forEach(eventName => {
        window.addEventListener(eventName, scrollHandler)
      })
    } else {
      setUserInteracted(true)
      return () => removeScrollHandler()
    }
    return () => removeScrollHandler()
  }, [])

  return userInteracted
}

export default useUserInteraction
